import axios from "@/apis/axios-client";

const GetAllTerminalSystems = async () => {

  return await axios.client
    .get(
      "/api/terminal/system",
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("GetAllTerminalSystems:", error);
      return error;
    });
};

const GetAllTerminals = async (filter) => {

  return await axios.client
    .get(
      filter ? `/api/terminal?filter=${filter}` : "/api/terminal",
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("GetAllTerminals:", error);
      return error;
    });
};

const SaveTerminalSystem = async (system) => {
  return await axios.client.put(
    "/api/terminal/system",
    system
  ).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
};

const SaveTerminal = async (terminal) => {
  return await axios.client.post(
    "/api/terminal",
    terminal
  ).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
};

const DeleteTerminal = async (id) => {
  return await axios.client.delete(
    `/api/terminal/${id}`
  ).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
};

const TerminalClockitApi = {
  GetAllTerminalSystems: GetAllTerminalSystems,
  SaveTerminalSystem: SaveTerminalSystem,
  GetAllTerminals: GetAllTerminals,
  SaveTerminal: SaveTerminal,
  DeleteTerminal: DeleteTerminal,
};

export default TerminalClockitApi;